import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import omitBy from 'lodash/omitBy';
import intersection from 'lodash/intersection';
import { createEntityCollection } from '../../utils/entity';
import ShareChannelPicker from '../share-channel-picker';
export var shareChannelMap = omitBy(ShareChannelPicker.Channel, function (x) {
  return x === ShareChannelPicker.Channel.SAVE_PHOTO;
});
export var shareChannelList = ShareChannelPicker.channelList.filter(function (x) {
  return x.value !== ShareChannelPicker.Channel.SAVE_PHOTO;
});
export var shareChannelCollection = createEntityCollection(shareChannelList, function (x) {
  return x.value;
});
export var normalizeChannels = function normalizeChannels(channels) {
  var defaultChannels = shareChannelList.map(function (x) {
    return x.value;
  });
  var result = intersection(defaultChannels, channels);
  return result.length > 0 ? result : defaultChannels;
};